import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  CashFund,
  CashFundSplitRow,
  CostCenterSummary,
  Identity,
} from '@libs/core/api';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NgxAuthService } from 'ngx-auth-utils';
import { first, Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'front-end-fund-cash-purchase-card',
  templateUrl: './fund-cash-purchase-card.component.html',
  styleUrls: ['./fund-cash-purchase-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashPurchaseCardComponent {
  @Input() project!: CostCenterSummary;
  @Input() cashFund?: CashFund;

  @Input() showSplit = false;
  @Input() splitRows: CashFundSplitRow[] = [];
  @Input() amount?: number;

  @Output() openSplitModalClick = new EventEmitter();

  readonly identity$: Observable<Identity> = this.authService.state.pipe(
    first()
  );

  constructor(private readonly authService: NgxAuthService) {}
}
